import React from 'react';
import { useTheme } from '../../../assets/contexts/ThemeContext';
import CustomSelect from '../../../components/widgets/CustomSelect';

/**
 * 상단 메뉴 정렬 제어 컴포넌트
 */
const MenuAlignControl = () => {
  const themeContext = useTheme();
  if (!themeContext) return null;
  const { themeConfig, set } = themeContext;

  return (
    <div id="menu-align-type-wrapper" style={{ marginBottom: '20px' }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: '6px', marginBottom: '6px' }}>
        <label style={{ fontSize: '13px', fontWeight: 'bold', color: '#333', margin: 0, flex: 1 }}>📍 상단 메뉴 정렬:</label>
        <button
          type="button"
          className="theme-help-btn"
          data-target="menu-align-type-wrapper"
          title="이 항목으로 이동"
          style={{
            background: 'transparent',
            border: '1px solid #ddd',
            color: '#666',
            fontSize: '11px',
            width: '20px',
            height: '20px',
            padding: 0,
            borderRadius: '50%',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}
          onMouseOver={(e) => {
            e.target.style.backgroundColor = '#f5f5f5';
            e.target.style.borderColor = 'var(--theme-color-primary)';
            e.target.style.color = 'var(--theme-color-primary)';
          }}
          onMouseOut={(e) => {
            e.target.style.backgroundColor = 'transparent';
            e.target.style.borderColor = '#ddd';
            e.target.style.color = '#666';
          }}
        >
          ?
        </button>
      </div>
      <CustomSelect
        value={themeConfig.menuAlign}
        onChange={(v) => set('menuAlign', v)}
        isSearchable={false}
        isClearable={false}
        options={[
          { value: 'left', label: '좌측 정렬' },
          { value: 'right', label: '우측 정렬' }
        ]}
        styles={{
          control: (base, state) => ({
            ...base,
            width: '100%',
            minHeight: 36,
            fontSize: 13,
            borderRadius: 4,
            borderColor: state.isFocused ? '#86b7fe' : '#ddd',
          }),
          valueContainer: (base) => ({ ...base, padding: '0 10px' }),
          indicatorsContainer: (base) => ({ ...base, height: 36 }),
        }}
      />
      <div style={{ fontSize: '11px', color: '#999', marginTop: '6px' }}>상단 배치일 때만 적용됩니다.</div>
    </div>
  );
};

export default MenuAlignControl;
